import AppConfig from 'classes/AppConfig'
import { PublicClientApplication } from '@azure/msal-browser';

export const requiresInteraction = errorMessage => {
    if (!errorMessage || !errorMessage.length) {
        return false;
    }

    return (
        errorMessage.indexOf("consent_required") > -1 ||
        errorMessage.indexOf("interaction_required") > -1 ||
        errorMessage.indexOf("login_required") > -1
    );
};

export const fetchMsGraph = async (url, accessToken) => {
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });

    return response.json();
};

export const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ") > -1;
    const msie11 = ua.indexOf("Trident/") > -1;

    // If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
    // const isEdge = ua.indexOf("Edge/") > -1;

    return msie || msie11;
};

export const SCOPES = {
    LOGIN: {
        scopes: [
            `${AppConfig.AzureADClientId}/.default`
        ]
    }
};

export const msalApp = new PublicClientApplication({
    auth: {
        clientId: AppConfig.AzureADClientId,
        authority: AppConfig.AzureADAuthority,
        validateAuthority: true,
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    },
    system: {
        navigateFrameWait: 0
    }
});